<template>
  <div class="table-container">
    <b-overlay center :show="isLoading" rounded="sm">
      <div v-if="!isLoading">
        <div v-if="ok">
          <validation-observer
            ref="observer"
            v-slot="{ invalid, handleSubmit }"
          >
            <b-form @submit.prevent="">
              <div class="form-card-wrapper">
                <b-card header-tag="header">
                  <template #header>
                    <b>Dati Identificativi</b>
                  </template>
                  <b-card-text>
                    <b-row>
                      <div class="form-group">
                        <base-input
                          vid="title"
                          :name="beForm[rep].title.label"
                          :label="beForm[rep].title.label"
                          v-model="form[rep].title"
                          placeholder="Inserisci un titolo"
                          :rules="getRules('title')"
                        />
                      </div>
                      <div class="form-group">
                        <base-input
                          vid="code"
                          :name="beForm[rep].code.label"
                          :label="beForm[rep].code.label"
                          v-model="form[rep].code"
                          placeholder="Inserisci un codice causale"
                          :rules="getRules('code')"
                        />
                      </div>
                      <div class="form-group">
                        <base-input
                          vid="caption"
                          :name="beForm[rep].caption.label"
                          :label="beForm[rep].caption.label"
                          v-model="form[rep].caption"
                          placeholder="Inserisci una descrizione"
                          :rules="getRules('caption')"
                        />
                      </div>
                    </b-row>
                  </b-card-text>
                </b-card>
              </div>
              <div class="form-actions form-actions--sticky">
                <div class="inner-wrapper">
                  <div>
                    <span
                      :title="`${
                        invalid
                          ? 'Compila correttamente i campi per poter salvare'
                          : 'Invia il form'
                      }`"
                    >
                      <b-button
                        @click="handleSubmit(onSubmit)"
                        type="button"
                        :disabled="invalid"
                        variant="lisaweb"
                        size="sm"
                        :title="`${
                          invalid
                            ? 'Compila correttamente i campi per poter salvare'
                            : 'Invia il form'
                        }`"
                      >
                        Salva
                      </b-button>
                    </span>
                  </div>
                  <div>
                    <b-button
                      @click="goBack()"
                      class="btn--transparent"
                      type="button"
                      title="Torna alla pagina precedente"
                    ><b-icon-chevron-double-left
                      font-scale="0.9"
                    ></b-icon-chevron-double-left
                    >Torna indietro</b-button
                    >
                  </div>
                </div>
              </div>

            </b-form>
          </validation-observer>
        </div>
        <div v-else>
          {{ errorMessage }}
        </div>
      </div>

      <template #overlay>
        <div class="text-center">
          <div class="custom-loader"></div>
          <p class="loading-text">Operazione in corso...</p>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import BaseInput from "@/components/form/BaseInput";
import ShortcutMixin from "@/mixins/ShortcutMixin";
import FormMixin from "@/mixins/FormMixin";

export default {
  mixins: [FormMixin, ShortcutMixin],
  data() {
    return {
      repository: "payment_reference",
      id: this.$route.params.id,
      section_opt: [],
      form: {
        payment_reference: {
          code: null,
          caption: null,
          title: null,
        },
      },
    };
  },
  components: {
    BaseInput,
  },
  methods: {
    goBack() {
      if (this.returnUrl) {
        switch (this.returnUrl) {
          case "accounting-payment-references-edit":
            this.$router.push({
              name: "payment_references.edit",
            });
            break;
          default:
            console.log(
              "No returnUrl set matched! Fallback to default back behavior."
            );
            this.$router.back();
            break;
        }
      } else {
        this.$router.back();
      }
    },
    onSubmit() {
      this.isLoading = true;
      this.form[this.rep].title =
        this.form[this.rep].code + " - " + this.form[this.rep].caption;
      this.update(this.repository, this.id)
        .then(() => {
          this.$store.dispatch("auth/payment_references");
          this.$showSnackbar({
            preset: "success",
            text: `Azione Completata: Causale Modificata`,
          });
          this.shortcut(
            "module.CONT.CONA",
            null,
            "#PaymentReferences",
            "filterPaymentReference"
          );
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  created() {
    this.isLoading = true;
    this.fetchEditForm(this.repository, this.id).then(() => {
      this.isLoading = false;
    });
  },
  computed: {
    rep() {
      return this.repository;
    },
  },
};
</script>
